import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";

import { mdiArrowLeft } from "@mdi/js";

import { DffPdfFremviserModule } from "@dffedb/pdf";
import { DffSideModule, SpinnerModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";

import { DokumentListeComponent } from "./dokument-liste/dokument-liste.component";
import { DokumentComponent } from "./dokument/dokument.component";
import { DokumenterRoutingModule } from "./dokumenter-routing.module";

@NgModule({
    imports: [
        CommonModule,
        DokumenterRoutingModule,
        DffSideModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        SpinnerModule,
        DffPdfFremviserModule
    ],
    exports: [],
    declarations: [DokumentListeComponent, DokumentComponent],
    providers: []
})
export class EForsyningFeaturesDokumenterModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiArrowLeft, "arrow-left");
    }
}
